export default __webpack_public_path__ + "static/media/kramer.0e30067a.gif";